// eslint-disable-next-line
import React, { useCallback, useEffect } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router';

import PrivateRoute from '../components/PrivateRoute/PrivateRoute';
import { UserSettingsDataProvider } from '../data/DataProviders/UserSettingsDataProvider';
import { AppDataProvider } from '../components/AppDataProvider';
import { ForgotPassword } from './forgot-password/ForgotPassword';
import { Registration } from './registration/Register';
import { ResetPassword } from './reset-password/ResetPassword';
import { Login } from './login/Login';

import { IdleTimerContainer } from '../components/IdleTimerContainer';
import UnsupportedBrowser from './unsupported-browser/UnsupportedBrowser';
import { isSupportedBrowser } from '../lib/browser-check';

import { Content } from './content';
import { OrganizationListProvider } from '../data/DataProviders/OrganizationListProvider';
import { DataProviderCache } from '../data/DataProviders/DataProviderCache';
import { OrganizationDataProvider } from '../data/DataProviders/OrganizationDataProvider';
import { SignalRConnectionProvider } from '../data/DataProviders/SignalRConnectionProvider';
import { UserInvitation } from './user-management/UserInvitation';
import { CustomerListProvider } from '../data/DataProviders/CustomerListProvider';
import { CustomerDataProvider } from '../data/DataProviders/CustomerDataProvider';
import { useTranslation } from 'react-i18next';
import { Selectors } from '../selectors';
import { useSelector } from 'react-redux';
import { languageList } from '../components/UserDetails/AccountPreferencesData';
import { SessionStorage } from '../components/AuthContextProvider/session-storage';
import { LoginCallback, Security } from '@okta/okta-react';
import OktaAuth, { OktaAuthOptions, toRelativeUrl } from '@okta/okta-auth-js';
import oktaConfig from '../oktaConfig';

const App: React.FC<React.PropsWithChildren<React.PropsWithChildren<unknown>>> = () => {
    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, -100);
        }, 500);
    }, []);

    const { i18n } = useTranslation();
    const userData = useSelector(Selectors.User.user);
    const lan = SessionStorage.readLanguage()

    const oktaAuth = new OktaAuth(oktaConfig as OktaAuthOptions);

    const history = useHistory();
    const navigation = useLocation();

   

    const restoreOriginalUri = (_oktaAuth: any, originalUri: any): void => {
        history.push(toRelativeUrl(originalUri || '/dashboard', window.location.origin));
    };
    const setLang = (value: number) => {
        // eslint-disable-next-line
        let userLang = languageList.filter((lang) => {
            if (lang.key === value)
                return lang.code;
        });
        if (userLang.length > 0 && userLang[0].code)
            return userLang[0].code;
    };

    useEffect(() => {
        if (!userData.getUserDetailLoading && userData.getUserDetailSuccess) {
            const lang = userData.userDetail.language;
            i18n.changeLanguage(setLang(lang));
        }
        else {
            i18n.changeLanguage(lan);
        }

    }, [userData.getUserDetailLoading, userData.getUserDetailSuccess, userData.getUserDetailFail]); // eslint-disable-line react-hooks/exhaustive-deps


    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <div className="full">
                <Switch>
                    <Route path={['/login', '/user-invitation', '/register', '/reset-password', '/unsupported-browser']}>
                       <Switch>
                            <Route exact path="/unsupported-browser" component={UnsupportedBrowser} />
                        </Switch>
                        {isSupportedBrowser() ? (
                            <Switch>
                                <Route exact path="/login" component={Login} />
                                <Route exact path="/register/:inviteUserType/:inviteUserEmail" component={Registration} />
                                <Route exact path="/user-invitation/:invitationId" component={UserInvitation} />
                                <Route path="/reset-password/:code" component={ResetPassword} />
                                <Route exact path={'/login/callback'} component={LoginCallback} />
                                <Redirect to="/login" />
                            </Switch>
                        ) : (
                            <Redirect to="/unsupported-browser"></Redirect>
                        )}
                    </Route>

                    <PrivateRoute path="*">
                        <AppDataProvider>

                            <IdleTimerContainer />
                            <UserSettingsDataProvider />
                            <DataProviderCache for="User Role">
                                <OrganizationListProvider>
                                    <CustomerListProvider>
                                        <SignalRConnectionProvider>
                                            <OrganizationDataProvider>
                                                <CustomerDataProvider>
                                                    <Content />
                                                </CustomerDataProvider>
                                            </OrganizationDataProvider>
                                        </SignalRConnectionProvider>
                                    </CustomerListProvider>
                                </OrganizationListProvider>
                            </DataProviderCache>
                        </AppDataProvider>
                    </PrivateRoute>

                </Switch>
            </div>
        </Security>
    );
};

export default App;
